const getVenueMatchesRange = (guestsInitialTarget: string | number | null = '') => {
  const lowerBound = Math.floor(Number(guestsInitialTarget) * 0.9);
  const upperBound = Number(guestsInitialTarget) * 2;

  return `${lowerBound}-${upperBound}`;
};

export default getVenueMatchesRange;
